import EFVideoFullScreenH5 from '@/components/UI/svg/Icons/EFVideoFullScreenH5';
import EFVideoPauseBigH5 from '@/components/UI/svg/Icons/EFVideoPauseBigH5';
import EFVideoPauseH5 from '@/components/UI/svg/Icons/EFVideoPauseH5';
import EFVideoPlayBigH5 from '@/components/UI/svg/Icons/EFVideoPlayBigH5';
import EFVideoPlayH5 from '@/components/UI/svg/Icons/EFVideoPlayH5';
import { f } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import 'video-react/dist/video-react.css';
import css from './index.module.scss';
const configs = {
    bgColor: '#000',
    navColor: '#fff',
    listColor: '#fff',
    src: '/video/aboutus.mp4',
    height: '720px',
    autoPlay: false,
    hideControl: false,
    disableDefaultControls: false,
    isShowTip: false,
    fullScreen: false,
};
export default function VideoModule({ config }: any) {
    const { useState, useEffect, useRef } = useGlobal();
    const [status, setStatus] = useState('pause');
    const [inZone, setInZone] = useState(false);
    const [screen, setScreen] = useState('portrait');
    const [video, setVideo] = useState({});
    const [processLeft, setProcessLeft] = useState(0);
    const [processWidth, setProcessWidth] = useState(0);
    const [totalTime, setTotalTime] = useState('00:00');
    const [currentTime, setCurrentTime] = useState('00:00');
    const configTypes = { ...configs, ...config };

    // 自定义控制条，播放事件
    const play = () => {
        video.play();
        setStatus('play');
    };
    const ref = useRef(null);
    // 自定义控制条，播放事件
    const pause = () => {
        video.pause();
        setStatus('pause');
    };
    // 暂停时点击视频，显示中间的播放按钮
    let videoClickTimer = null;
    const videoClick = () => {
        setInZone(true);
        clearTimeout(videoClickTimer);
        videoClickTimer = setTimeout(() => {
            setInZone(false);
        }, 3000);
    };
    // 时间处理函数，用于显示总时间跟播放的时间
    const timeStamp = (second_time: number) => {
        const time = Math.floor(second_time);
        if (time < 60) {
            return `00:${time < 10 ? `0${time}` : time}`;
        } else {
            const time1 = Math.floor(time / 60);
            const time2 = time % 60;
            return `${time1 < 10 ? `0${time1}` : time1}:${time2 < 10 ? `0${time2}` : time2}`;
        }
    };
    // 获取video的总时长，同时使用定时器监听缓冲时间变化
    const getVideoDuration = () => {
        console.log(video.duration);
        const videoBuffered = document.querySelector('#videoCache');
        const timer = setInterval(() => {
            const buffered_time = video.buffered.end(0);
            const buffered_percent = `${Math.round((buffered_time / video.duration) * 1000) / 10}%`;
            videoBuffered?.setAttribute('style', `width: ${buffered_percent}`);
            if (buffered_percent == '100%') {
                clearInterval(timer);
            }
        }, 1000);
        setTotalTime(timeStamp(video.duration));
        setProcessLeft(ref.current.offsetLeft);
        setProcessWidth(ref.current.clientWidth);
    };
    // 当视频播放时获取当前播放到哪
    const getCurrentTime = () => {
        const videoPlayed = document.querySelector('#videoPlayed');
        const played_percent = `${Math.round((video.currentTime / video.duration) * 1000) / 10}%`;
        videoPlayed?.setAttribute('style', `width:${played_percent}`);
        setCurrentTime(timeStamp(video.currentTime));
    };

    const testTouch = (evt: any) => {
        const videoPlayed = document.querySelector('#videoPlayed');
        const played_percent = Math.round(((evt.targetTouches[0].clientX - processLeft) / processWidth) * 1000) / 10;
        videoPlayed?.setAttribute('style', `width:${played_percent}%`);
        video.currentTime = video.duration * (played_percent / 100);
        setCurrentTime(timeStamp(video.currentTime));
    };
    const testTouchMove = (evt: any) => {
        const videoPlayed = document.querySelector('#videoPlayed');
        if (evt.targetTouches[0].clientX - processLeft <= processWidth) {
            const played_percent = Math.round(((evt.targetTouches[0].clientX - processLeft) / processWidth) * 1000) / 10;
            videoPlayed?.setAttribute('style', `width:${played_percent}%`);
            video.currentTime = video.duration * (played_percent / 100);
            setCurrentTime(timeStamp(video.currentTime));
        }
    };
    useEffect(() => {
        setVideo(document.querySelector('#videoContent'));
        function resize() {
            if (window.orientation == 0 || window.orientation == 180) {
                setScreen('portrait');
                setTimeout(() => {
                    setProcessLeft(ref.current.offsetLeft);
                    setProcessWidth(ref.current.clientWidth);
                });
            } else {
                setScreen('landscape');
                setTimeout(() => {
                    setProcessLeft(ref.current.offsetLeft);
                    setProcessWidth(ref.current.clientWidth);
                });
            }
        }
        // process_bar?.addEventListener('touchstart', testTouch, false)
        window.addEventListener('orientationchange', resize, false);
    }, []);
    const fullScreen = () => {
        if (video.requestFullscreen) {
            video?.requestFullscreen();
        } else if (video.mozRequestFullScreen) {
            video.mozRequestFullScreen();
        } else if (video.webkitRequestFullscreen) {
            video.webkitRequestFullscreen();
        } else if (video.webkitSupportsFullscreen) {
            video.webkitEnterFullscreen();
        }
    };
    return (
        <div className={`${css.VideoModule} videoModules`} style={{ background: configTypes.bgColor }}>
            <div
                className="video-wrap"
                style={{
                    height: '2.11rem',
                    width: '100%',
                }}
            >
                <video
                    className="video"
                    id="videoContent"
                    src={f('/video/aboutus.mp4')}
                    onTimeUpdate={getCurrentTime}
                    onEnded={() => {
                        setStatus('pause');
                    }}
                    onLoadedData={getVideoDuration}
                    height={'100%'}
                    width={'100%'}
                    webkit-playsInline="true"
                    playsInline={true}
                    onClick={videoClick}
                />
                <div className="control">
                    <div className="video-play" style={{ display: status === 'play' ? 'none' : 'block' }} onClick={play}>
                        <EFVideoPlayH5 />
                    </div>
                    <div className="video-pause" style={{ display: status === 'play' ? 'block' : 'none' }} onClick={pause}>
                        <EFVideoPauseH5 />
                    </div>
                    <div className="video-played-time">{currentTime}</div>
                    <div ref={ref} className="video-process" id="videoProcess" onTouchStart={testTouch} onTouchMove={testTouchMove}>
                        <div className="video-cache-bar" id="videoCache"></div>
                        <div className="video-played-bar" id="videoPlayed"></div>
                    </div>
                    <div className="video-total-time">{totalTime}</div>
                    <div className="video-fullScreen" onClick={fullScreen}>
                        <EFVideoFullScreenH5 />
                    </div>
                </div>
                <div className="videoButton" style={{ display: status === 'play' ? 'none' : 'block' }} onClick={play}>
                    <EFVideoPlayBigH5 />
                </div>
                <div className="videoButton" style={{ display: status === 'play' && inZone ? 'block' : 'none' }} onClick={pause}>
                    <EFVideoPauseBigH5 />
                </div>
            </div>
        </div>
    );
}
